import { server } from '@/helpers';
import { AdyenPaymentRequest } from '@/types/api/services/booking';
import { Giftcard } from '@/types/state/book';

export interface BookingCheckoutResponse {
  sessionId: string;
  sessionData: string;
  paymentId: number;
  bookingId: number;
  checkoutRef: string;
}

export interface PrepayBookingRequest {
  bookingId: number;
  paymentMethod: number;
  giftcards?: Giftcard[];
  redirectInfo: {
    returnUrl: string;
    channel: 'Web' | 'iOS' | 'Android';
    browserInfo?: {
      acceptHeader?: string;
      colorDepth?: number;
      javaEnabled?: boolean;
      language?: string;
      screenHeight?: number;
      screenWidth?: number;
      timeZoneOffset?: number;
      userAgent?: string;
    };
  };
  savedCardId?: string;
  walleyPhoneNumber?: string;
}

/**
 * Process booking checkout
 * Handles the checkout process for bookings including payment processing
 */
function checkout(data: AdyenPaymentRequest): Promise<BookingCheckoutResponse> {
  return server.request.post('/booking/checkout', data).then(server.handleSuccess).catch(server.handleErrorObject);
}

/**
 * Prepay an existing booking
 * Adds payment to an existing booking that was booked without payment
 */
function prepayBooking(data: PrepayBookingRequest): Promise<BookingCheckoutResponse> {
  return server.request
    .post(`/booking/checkout/${data.bookingId}`, data)
    .then(server.handleSuccess)
    .catch(server.handleErrorObject);
}

export const bookingsServices = {
  checkout,
  prepayBooking,
};
